import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api, { getApiOrigin } from '../services/api';
import BarreRecherche from '../composants/BarreRecherche';
import { usePanier } from '../contexte/PanierContexte';
import Hero from '../composants/Hero';
import SkeletonCard from '../composants/SkeletonCard';

export default function Accueil() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { ajouter } = usePanier();

  const recherche = params.get('recherche') || '';
  const categorieParam = params.get('categorie_id') || '';

  const [categories, setCategories] = useState([]);
  const [produits, setProduits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erreur, setErreur] = useState('');
  const [messagePanier, setMessagePanier] = useState('');
  const [erreurPanier, setErreurPanier] = useState('');

  const categorieActive = categorieParam ? Number(categorieParam) : null;



  useEffect(() => {
    let mounted = true;

    async function charger() {
      setLoading(true);
      setErreur('');
      try {
        const [cats, prods] = await Promise.all([
          api.get('/categories'),
          api.get('/produits')
        ]);

        if (!mounted) return;
        setCategories(cats.data);
        setProduits(prods.data);
      } catch (e) {
        if (!mounted) return;
        setErreur(e?.response?.data?.message || e?.message || 'Chargement impossible');
      } finally {
        if (mounted) setLoading(false);
      }
    }

    charger();
    return () => {
      mounted = false;
    };
  }, []);

  function choisirCategorie(id) {
    const next = new URLSearchParams(params);
    if (id) next.set('categorie_id', String(id));
    else next.delete('categorie_id');
    navigate({ pathname: '/', search: next.toString() });
  }

  function rechercher(q) {
    const next = new URLSearchParams(params);
    if (q) next.set('recherche', q);
    else next.delete('recherche');
    navigate({ pathname: '/', search: next.toString() });
  }

  function formatterPrix(prix) {
    return new Intl.NumberFormat('fr-FR').format(prix) + ' FCFA';
  }

  function normaliserUrlImage(url) {
    if (!url) return null;
    const s = String(url);
    if (s.startsWith('http://') || s.startsWith('https://')) return s;
    const origin = getApiOrigin().replace(/\/$/, '');
    if (s.startsWith('/uploads')) return `${origin}${s}`;
    if (s.startsWith('uploads/')) return `${origin}/${s}`;
    return s;
  }

  function ajouterProduitAuPanier(produit) {
    setMessagePanier('');
    setErreurPanier('');

    const variantes = produit?.variantes || produit?.variantes_produit || [];
    const variante = variantes?.[0] || null;

    if (!variante) {
      setErreurPanier('Veuillez choisir une variante.');
      window.setTimeout(() => setErreurPanier(''), 2500);
      navigate(`/produits/${produit.id}`);
      return;
    }

    ajouter({
      produit_id: produit.id,
      variante_id: variante.id,
      nom: produit.nom,
      variante_libelle: `${variante.nom_variante} : ${variante.valeur_variante}`,
      prix_unitaire: Number(variante.prix || 0),
      image_url: normaliserUrlImage(produit?.images?.[0]?.url_image || produit?.images_produit?.[0]?.url_image || null),
      quantite: 1
    });

    setMessagePanier('Ajouté au panier');
    window.setTimeout(() => setMessagePanier(''), 2500);
  }

 

  const produitsFiltres = useMemo(() => {
    let items = Array.isArray(produits) ? produits : [];

    if (categorieActive) {
      items = items.filter((p) => {
        const catId = Number(p.categorie_id || p.categorie?.id || 0);
        return catId === categorieActive;
      });
    }

    if (recherche) {
      const q = recherche.toLowerCase();
      items = items.filter((p) => {
        const nom = String(p.nom || '').toLowerCase();
        const desc = String(p.description || '').toLowerCase();
        return nom.includes(q) || desc.includes(q);
      });
    }

    return items;
  }, [produits, categorieActive, recherche]);

  return (
    <div className="min-h-screen bg-gray-50">
      {erreurPanier ? (
        <div className="fixed left-1/2 top-20 z-50 w-[min(560px,calc(100%-2rem))] -translate-x-1/2 rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700 shadow-lg">
          <div className="flex items-center justify-between gap-3">
            <div>{erreurPanier}</div>
            <button
              onClick={() => setErreurPanier('')}
              className="rounded-xl border border-rose-200 bg-white px-3 py-2 text-xs font-semibold text-rose-700 hover:bg-rose-50"
            >
              Fermer
            </button>
          </div>
        </div>
      ) : null}
      {messagePanier ? (
        <div className="fixed left-1/2 top-20 z-50 w-[min(560px,calc(100%-2rem))] -translate-x-1/2 rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-700 shadow-lg">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <div>{messagePanier}</div>
            <div className="flex items-center gap-2">
              <button
                onClick={() => navigate('/panier')}
                className="rounded-xl bg-emerald-600 px-3 py-2 text-xs font-semibold text-white hover:bg-emerald-500"
              >
                Voir panier
              </button>
              <button
                onClick={() => setMessagePanier('')}
                className="rounded-xl border border-emerald-200 bg-white px-3 py-2 text-xs font-semibold text-emerald-700 hover:bg-emerald-100"
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      ) : null}

      
      <Hero />
      {/* vos bannières promotionnelles */}
     
      

      {/* Bannières Promotionnelles */}
      <section className="py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-blue-500 to-purple-600 p-8 text-white shadow-xl">
              <h3 className="text-2xl font-bold mb-4">Livraison gratuite</h3>
              <p className="mb-4">Pour toute commande supérieure à 50 000 FCFA</p>
              <button className="bg-white text-blue-600 font-semibold py-2 px-6 rounded-lg hover:bg-gray-100 transition-colors duration-200">
                En savoir plus
              </button>
            </div>
            <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-green-500 to-teal-600 p-8 text-white shadow-xl">
              <h3 className="text-2xl font-bold mb-4">Paiement sécurisé</h3>
              <p className="mb-4">Carte bancaire, Mobile Money et espèces</p>
              <button className="bg-white text-green-600 font-semibold py-2 px-6 rounded-lg hover:bg-gray-100 transition-colors duration-200">
                Découvrir
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Articles (depuis la base de données) */}
      <section id="produits" className="py-16 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
            <div>
              <h2 className="text-3xl font-bold text-gray-900">Articles</h2>
              <p className="mt-2 text-sm text-gray-600">Découvrez tous les produits disponibles.</p>
            </div>
            <div className="w-full md:max-w-md">
              <BarreRecherche valeurInitiale={recherche} onRechercher={rechercher} />
            </div>
          </div>

          <div className="mt-6 flex flex-wrap items-center gap-2">
            <button
              onClick={() => choisirCategorie(null)}
              className={
                !categorieActive
                  ? 'rounded-full bg-orange-500 px-4 py-2 text-xs font-semibold text-white'
                  : 'rounded-full border border-gray-200 bg-white px-4 py-2 text-xs font-semibold text-gray-800 hover:bg-gray-50'
              }
            >
              Toutes
            </button>
            {categories.map((c) => (
              <button
                key={c.id}
                onClick={() => choisirCategorie(c.id)}
                className={
                  categorieActive === Number(c.id)
                    ? 'rounded-full bg-orange-500 px-4 py-2 text-xs font-semibold text-white'
                    : 'rounded-full border border-gray-200 bg-white px-4 py-2 text-xs font-semibold text-gray-800 hover:bg-gray-50'
                }
              >
                {c.nom}
              </button>
            ))}
          </div>

          {erreur ? (
            <div className="mt-8 rounded-2xl border border-rose-200 bg-rose-50 p-4 text-sm text-rose-700">{erreur}</div>
          ) : null}

          {loading ? (
            <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
              {[1, 2, 3, 4].map((i) => <SkeletonCard key={i} />)}
            </div>
          ) : produitsFiltres.length ? (
            <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
              {produitsFiltres.map((p) => (
                <div
                  key={p.id}
                  className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-200 overflow-hidden"
                >
                  <div className="aspect-square overflow-hidden bg-gray-100">
                    {(() => {
                      const image = p?.images?.[0]?.url_image || p?.images_produit?.[0]?.url_image || null;
                      const src = normaliserUrlImage(image);
                      return src ? (
                        <img
                          src={src}
                          alt={p.nom}
                          className="w-full h-full object-cover hover:scale-105 transition-transform duration-200"
                        />
                      ) : (
                        <div className="flex h-full w-full items-center justify-center text-xs text-gray-500">Aucune image</div>
                      );
                    })()}
                  </div>
                  <div className="p-4">
                    <h3 className="font-bold text-lg text-gray-900 mb-2">{p.nom}</h3>
                    <p className="text-gray-600 text-sm mb-3">{p.description || ' '}</p>
                    <div className="flex items-center justify-between">
                      <span className="text-2xl font-bold text-orange-500">
                        {(() => {
                          const variantes = p?.variantes || p?.variantes_produit || [];
                          const prixMin = variantes.length ? Math.min(...variantes.map((v) => Number(v.prix || 0))) : 0;
                          return formatterPrix(prixMin);
                        })()}
                      </span>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          ajouterProduitAuPanier(p);
                        }}
                        className="bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 px-4 rounded-lg transition-colors duration-200"
                      >
                        Ajouter
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="mt-10 rounded-2xl border border-gray-200 bg-gray-50 p-6 text-sm text-gray-600">
              Aucun article trouvé.
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
